iScreenWizard.factory('RapporttemplateCompetentieprofieltype', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        return $q(function (resolve, reject) {
            Ajax.get('rapporttemplatecompetentieprofieltype').then(function (response) {
                var rapporttemplatecompetentieprofieltypes = response.data;
                resolve(rapporttemplatecompetentieprofieltypes);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('rapporttemplatecompetentieprofieltype/'+id).then(function (response) {
                var rapporttemplatecompetentieprofieltype = response.data;
                resolve(rapporttemplatecompetentieprofieltype);
            }, reject);
        });
    };

    return data;
});